import { render, staticRenderFns } from "./DomeinlijstOverview.vue?vue&type=template&id=2c2ac3c1&"
import script from "./DomeinlijstOverview.vue?vue&type=script&lang=js&"
export * from "./DomeinlijstOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports